<template>
  <div>
    <div v-for="comment in comments" :key="comment.id">
      <comment-display :item="item" :comment="comment" />
      <v-divider class="mx-2 mt-4"></v-divider>
    </div>
  </div>
</template>

<script>
import CommentDisplay from '@/components/postEditor/parts/comments/CommentDisplay'

export default {
  components: {
    CommentDisplay
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    comments: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="sass"></style>
